// @flow
import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';

// import closeEsp from 'fg-frontend/webActions/closeEsp';
// import goBack from 'fg-frontend/webActions/goBack';
// import scrollToHref from 'fg-frontend/webActions/scrollToHref';
// import confirmPopup from 'fg-frontend/webActions/confirmPopup';
// import passwordStrength from 'fg-frontend/webActions/passwordStrength';
// import toggleClass from 'fg-frontend/webActions/toggleClass';
// import printPage from 'fg-frontend/webActions/printPage';

// import configureEshopActions from './configureEshopActions';

export default (action) => {
  switch (action) {
    case 'hsExpand':
      return (props, e) => {
        e.preventDefault();
        CursorSpinner.pushToQueue('importHsExpand');
        import('./webActions/hsExpand').then((hsExpand) => {
          CursorSpinner.removeFromQueue('importHsExpand');
          hsExpand.default(props, e);
        });
      };
    case 'execute':
      return execute;
    default:
      const eshopAction = configureEshopActions(action);
      if (eshopAction) {
        return eshopAction;
      }

      console.log('Unknown action');
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebActions.js